import styles from "../../../styles/profile.module.css";
import { Grid, Typography, Avatar, Box } from "@mui/material";
import { authSelector } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import useOnlineStatus from "../../../common/utils/OnlineStatusProvider";
import Offline from "../../../common/pages/Offline";
import { stringAvatar } from "../../utils/helperFunctions";

const Profile = () => {
  const isOnline = useOnlineStatus();
  const auth = useSelector(authSelector);

  const userInfo = auth.user;
  const displayName = userInfo?.name || userInfo?.preferred_username || 'Utilisateur';
  const email = userInfo?.email || 'Non disponible';
  const roles = userInfo?.roles || [];
  

  if (isOnline) {
    return(
      <div className={styles.profilePage}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={3}
        >
          <Grid item xs={12} className={styles.header}>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar {...stringAvatar(displayName, "#1976d2")} sx={{ width: 64, height: 64 }} />
              <Typography variant="h4" component="h1">
                Votre Profil
              </Typography>
            </Box>
          </Grid>

          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={2}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', paddingLeft: '10px' }}>
                Nom complet :
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <div className={styles.infos}>{displayName}</div>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={2}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', paddingLeft: '10px' }}>
                Email :
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <div className={styles.infos}>{email}</div>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={2}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', paddingLeft: '10px' }}>
                Rôles :
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <div className={styles.infos}>
                {roles.length > 0 ? roles.join(', ') : 'Aucun rôle assigné'}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  } else {
    return (<Offline/>)
  }
}

export default Profile;